import React from 'react';
import { FieldSet, Section } from '@alfa-retail-react/components';

const advantages = [
    {
        value: 'Оплачивайте покупки в любых магазинах или онлайн, даже товары на акциях и распродажах.',
        className: 'advantagesListItem',
    },
    {
        value: 'Снимайте наличные в банкоматах, платите за услуги в ЕРИП или переводите с карты на карту.',
        className: 'advantagesListItem',
    },
];

const insurance = [
    {
        value: 'Можно оформить выгодный пакет страхования от несчастных случаев и заболеваний.',
        className: 'advantagesListItem',
    },
];

export const IntroKkgProductAdvantages = () => {
    return (
        <>
            <Section
                className="IntroProductAdvantages"
                title="Льготный период на всё"
            >
                <FieldSet className="advantagesList" fieldsProps={advantages} />
            </Section>
            <Section
                className="IntroProductAdvantages"
                title="Защитите себя от несчастных случаев"
            >
                <FieldSet className="advantagesList" fieldsProps={insurance} />
            </Section>
        </>
    );
};
